// alert-dialog-confirm-apply.tsx
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'

interface AlertDialogConfirmApplyProps {
  open: boolean
  setOpen: (open: boolean) => void
  handleApply: () => void
}

function AlertDialogConfirmApply({
  open,
  setOpen,
  handleApply,
}: AlertDialogConfirmApplyProps) {
  return (
    <>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Konfirmasi Lamaran Pekerjaan</AlertDialogTitle>
            <AlertDialogDescription>
              Anda dapat melamar 3 pekerjaan dalam satu waktu. Anda
              dapat mencoba melamar pekerjaan lain setelah salah satu lamaran Anda
              ditolak oleh perusahaan.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <Button onClick={() => handleApply()}>
              <AlertDialogAction>Lamar Sekarang</AlertDialogAction>
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}

export default AlertDialogConfirmApply
